import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import ModalContent from "../../../common/Modal/ModalContent";
import close_modal from "./../../../assets/ic_close_wh.svg";
import moment from "moment";
import find from "lodash/find";
import { getServiceTypesMaster } from "../../../utils/localStorage";
import ReactTable from "react-table";
import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";
const ReactTableFixedColumns = withFixedColumns(ReactTable);

export default function ServiceRequestAssignmetSummaryModal(props)
{
    const getServiceName = (original) => {
		if (!original) return;
		const found = find(getServiceTypesMaster(), {
			sServiceCode: original.sServiceCode,
		});
		if (found) {
			return found.sServiceName;
		}
		return "";
	};

    const columns = [
        {
            id: "service_name",
            Header: "Service Name",
            headerStyle:{'borderBottom':'solid 1px #ccc'},
            accessor: "nResourceInstanceId",
            style: { 'whiteSpace': 'unset' },
            Cell: ({ original }) => (
                    <>
                            <span>
                                {
                                    original.sServiceName ? 
                                    original.sServiceName :
                                    getServiceName(original)
                                }
                            </span><br></br>
                            <span>
                                {`ID:${original.nResourceInstanceId}`}
                            </span>
                    </>
                ),
        },
        
        {
            id: "sFirstName"+"service_id",
            Header: "Customer Details",
            headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
            accessor: "nResourceInstanceId",
            style: { 'whiteSpace': 'unset' },
            width:300,
            Cell: ({ original }) => (
                <>
                    <div className={"conv-float-left"}>
                        <div>
                            <span className="conv-float-left conv-mr18">Name:</span>
                            <span style={{wordBreak:"break-all",float:"right",width:"200px"}}>
                                {
                                    original.sEmailAddress
                                }
                            </span><br></br>											
                        </div>
                        <div style={{"clear":"both"}}></div>
                        <div className="conv-mt10">
                        <span className="conv-float-left conv-mr5">Contact:</span>
                            <span style={{wordBreak:"break-all",float:"right",width:"200px"}}>										
                                {
                                    original.sContactNumber
                                }
                            </span>
                        </div>
                    </div>
                </>
            ),
        },
        
        {
            id: "dtFollowupOn",
            Header: "Follow Up",
            accessor: "dtFollowupOn",
            width:150,
            Cell: ({ original }) => {
                return original["dtFollowupOn"] ? (
                    <span style={{whiteSpace:"break-spaces",width:"150px"}}>
                        {moment(
                            moment.utc(original["dtFollowupOn"]).toDate()
                        ).format("DD MMM YYYY")}
                    </span>
                ) : (
                    <span>-</span>
                );
            },
        },
        {
            id: "service_status",
            Header: "Status",
            headerStyle:{'borderBottom':'solid 1px #ccc'},
            accessor: "nResourceInstanceId",
            style: { 'whiteSpace': 'unset' },
            width:150,
            Cell: ({ original }) => (
                    <>
                        {props.useForSPM ? (
                            <span>
                                {original["refCurrentState"]["sServiceState"]}
                            </span>
                        ) : (
                            <span>
                                {original["refSRState"]}
                            </span>
                        )}
                    </>
                ),
        },
    ];

    const renderbulkAssignServiceRequest = () => {
		const temp = props.bulkAssignServiceRequest;
		if (Object.keys(props.bulkAssignServiceRequest).length > 0) 
        {
			return Object.entries(temp).map(([key, value]) => {
				console.log("value", value);
				if (typeof value !== "object")
					return (
						<>
                           <div className="col-12 conv-mt20">
                                <span className="customer-details conv-float-left">Customer email : {key}</span>
                                <span className="customer-details conv-float-right">Number of services : 0</span>
                            </div>
                            <div className="col-12 conv-mt20">
                                <span>{value}</span>
                            </div>
                            {
                                /*<div style={{ padding: "10px" }}>
                                    <div style={{padding: "5px",}}>
                                        <span>Customer email : <b>{key}</b></span>
                                        <span style={{float: "right",}}>
                                            Number of services : <b>0</b>
                                        </span>
                                    </div>
                                    <span>{value}</span>
                                </div>*/
                            }
                    </>
					);

				return (
					<>
                        <div className="col-12 conv-mt20">
                            <span className="customer-details conv-float-left">
                                Customer email : {" "}
                                {props.useForSPM && value[0]["customer_meta"] &&
                                Object.keys(value[0]["customer_meta"]).length ? 
                                (
                                    <>{value[0]["customer_meta"]["email"]}</>
                                ): 
                                (
                                    <>{key}</>
                                )}
                            </span>
                            <span className="customer-details conv-float-right">Number of services : <>{value.length}</></span>
                        </div>
						<div className="col-12 conv-mt10 service-partner spled-container">
                            <ReactTableFixedColumns
                                key={key}
                                minRows={0}
                                data={value || []}
                                columns={columns}
                                sortable={false}
                                showPagination={false}
                                className="-striped hide-scrollbar"
                            />
							{/*<table style={{ tableLayout: "fixed" }}>
								<tr>
									<th>Instance Id</th>
									<th>Service Name</th>
									<th>Email(SR)</th>
									<th>Phone Number(SR)</th>
									<th>Follow up</th>
									<th>Current State</th>
								</tr>
								{x}
                                </table>*/}
						</div>
					</>
				);
			});
		} 
        else 
        {
			return (
				<>
					<span
						style={{
							padding: "10px 10px",
							paddingInline: "10px",
							backgroundColor: "#eac1c1",
							display: "inline-block",
						}}
					>
						A handholder cannot be assigned to the service requests
						that you have selected. Please make sure that you have
						selected correct service requests
					</span>
				</>
			);
		}
	};

    return (
        <Modal
            isOpen={props.isOpen}
            onRequestClose={props.toggleModal}
            ariaHideApp={false}
        >
          <ModalContent className="service-assignment-summary-modal">
            <div className="modal-header">
                <span className="modal-title">Detail Summary</span>
                <span className="modal-secondary-title">Total No. of Services: {props.numberOfServices} </span>
                <img
                    alt="close"
                    id="Close"
                    src={close_modal}
                    className="close modal-close"
                    onClick={props.toggleModal}
                />
            </div>
            
            <div className={`modal-body spled-container notes-trail-content custom-scrollbar`}>
                <div className="row conv-mt10">
                    {renderbulkAssignServiceRequest()}
                </div>                
            </div>
          </ModalContent>
        </Modal>
      );
}